import React, {useCallback, useEffect, useState} from 'react';
import {Marker, useMap} from "react-leaflet";
import {  LocationMarkerIcon  } from '../MarkersIcon/MarkerIcon';
import L from 'leaflet';

//import markers css
import './Markers.css'
import useStoresData from "../../hooks/useStoresData";

/**
 * Get user location, add location marker on the leaflet map and setView to this
 * marker.
 * @returns {null|JSX.Element}
 * @constructor
 */
const GeoLocationMarker = (props) => {

    const [position, setPosition] = useState(null)
    const map = useMap()
    const isLoading = props.isLoading

    const setMyLocationMarker = useCallback((e) => {
        //get accuracy of the location
        const radius = e.accuracy;
        //get postion of the user
        const latlng = e.latlng;

        //Set position state to the current position of the user
        setPosition(latlng);

        //Create the accuracy circle under the location marker
        const circle = L.circle(latlng, {
            radius,
            color: '#26c6da'
        });

        //Add accuracy circle to the map
        circle.addTo(map)

        //Set view of the map on user location
        map.setView(e.latlng);

    },[isLoading])

    useEffect(() => {

        //Get and check if location found
        map.locate().on('locationfound',setMyLocationMarker)

        return () => {
            map.locate().off('locationfound',setMyLocationMarker)
        }

    },[map])

    return position === null ? null : (
        <Marker id={'location-marker'} position={position} icon={LocationMarkerIcon}>

        </Marker>
    )
}

export default GeoLocationMarker